const AuthRoutes = {
    path: '/',
    component: () => import('@/layouts/blank/BlankLayout.vue'),
    meta: {
        requiresAuth: false
    },
    redirect: { name: 'AUTH' },
    /* This part of the code defines the nested routes for authentication within the main route
    configuration. Here's a breakdown: */
    children: [
        {
            path: 'auth',
            name: 'AUTH',
            redirect: { name: 'Login' },
            children: [
                {
                    path: 'login/:hash_folio?',
                    name: 'Login',
                    component: () => import('@/views/authentication/SideLoginV2.vue')
                },
                {
                    path: 'impersonate/:hash/:restricted(ABC|XLD)',
                    name: 'Impersonate',
                    component: () => import('@/views/authentication/Impersonate.vue'),
                    props: {
                        apiUrl: import.meta.env.VITE_API_URL
                    },
                    beforeEnter: (to: { params: { restricted: string } }, _from: any, next: (to?: any) => void) => {
                        // "ABC" para portales restringidos
                        // "XLD" para portales NO restringidos

                        const allowedValues = ['ABC', 'XLD'];
                        if (allowedValues.includes(to.params.restricted)) {
                            next();
                        } else {
                            // creo que se debe cerrar sesión aquí
                            next({ name: 'Login' });
                        }
                    }
                },
                {
                    path: 'recovery/:hash_password/:hash_folio?',
                    name: 'ConfirmPassword',
                    component: () => import('@/views/authentication/LoginConfirmPassword.vue')
                },
                {
                    path: 'recovery-code',
                    name: 'RecoveryCode',
                    component: () => import('@/views/authentication/RecoveryCode.vue')
                }
            ]
        },
        {
            path: 'wallet/:policy_hash?',
            name: 'Wallet',
            component: () => import('@/views/public/wallet/PolicySignature.vue')
        },
        {
            path: 'aviso_de_privacidad',
            name: 'Aviso de Privacidad',
            component: () => import('@/views/public/AvisoPrivacidad.vue')
        },
        {
            path: 'maintenance',
            name: 'Maintenance',
            component: () => import('@/views/public/Maintenance.vue')
        },
        {
            path: 'recibo/:rh/:token',
            name: 'PaymentConfirmation',
            component: () => import('@/views/public/payment-confirmation/index.vue')
        }
    ]
};

export default AuthRoutes;
